import Download from 'assets/download.svg?react'
import Trash from 'assets/trash.svg?react'
import { ArrowRightIcon, PencilIcon, X } from 'lucide-react'
import styled from 'styled-components'

export const DownloadIcon = styled(Download)`
  width: 1rem;
  height: 1rem;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
`

export const StyledTrashIcon = styled(Trash)`
  width: 1rem;
  height: 1rem;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
`

export const StyledPencilIcon = styled(PencilIcon)`
  width: 1rem;
  height: 1rem;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
`

export const StyledArrowRightIcon = styled(ArrowRightIcon)`
  width: 1rem;
  height: 1rem;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
`

export const StyledCloseIcon = styled(X)`
  height: 1rem;
  width: 1rem;
`

export const StyledInput = styled.input`
  border-radius: 0.25rem;
  border-color: transparent;
  border-width: 0;
  color: ${({ theme }) => theme.forecast.defaultText};
  background-color: ${({ theme }) => theme.forecast.cardGroupBackground};
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem;

  &::placeholder {
    color: ${({ theme }) => theme.forecast.secondaryText};
  }
`

export const MultiSelectInput = styled(StyledInput)`
  width: 1rem;
  height: 1rem;
  cursor: pointer;
`

export const StyledLabel = styled.label`
  display: flex;
  align-items: flex-start;
  min-width: 4rem;
  color: ${({ theme }) => theme.forecast.defaultText};
  font-weight: 500;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  padding: 0 0.25rem;
`

export const LabelAndInputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.25rem;
  width: max-content;
`

export const RelativeWrap = styled.div`
  position: relative;
  z-index: 10;
`

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  margin-top: 0.25rem;
  min-height: 2.5rem;
  padding: 0.25rem 0.5rem;
  justify-content: flex-start;
  justify-content: center;
  gap: 0.5rem;
  align-self: stretch;
  border-radius: 0.25rem;
  background-color: ${({ theme }) => theme.forecast.glassBackground};
  backdrop-filter: blur(2rem);
  box-shadow:
    0 0.063rem 0.125rem 0 rgba(0, 0, 0, 0.1),
    0 0.25rem 0.5rem 0 rgba(0, 0, 0, 0.1);
  -webkit-backdrop-filter: blur(2rem);
`
